import React from "react";
import { Typography } from "@mui/material";
import { getParams, formatReportGender } from "../../utils/helpers";
import "./userdetails.scss";

const UserDetails = ({ name, firstName, lastName, gender, age }) => {
  const { locale } = getParams();
  const displayGender = formatReportGender(gender, locale);

  const getFormattedName = () => {
    if (firstName && lastName) {
      if (locale === "ja" || locale === "zh") {
        return `${lastName} ${firstName}`;
      }
      return `${firstName} ${lastName}`;
    }
    return name;
  };

  return (
    <div className="user-info-wrap">
      <div className="user-img-name">
        {/* <img src={img} alt="user" className="img" /> */}
        <div className="name-wrapper">
          <Typography className="name">{getFormattedName()}</Typography>

          <div className="age-gender-wrapper">
            <Typography className="gender">{displayGender}</Typography>
            {displayGender && age ? <div className="straight-line"></div> : ""}
            <Typography className="age">{age === 0 ? "" : age}</Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserDetails;
